import { useState } from "#imports";
export const useStrapiUser = () => useState("strapi_user");
